import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import i18n from './modules/i18n';
import cart from './modules/cart';
import user from './modules/user';
import layer from './modules/layer';
import search from './modules/search';
import script from './modules/script';
import seller from './modules/seller';
import request from './modules/request';
import category from './modules/category';
import wishlist from './modules/wishlist';
import analytics from './modules/analytics';
import sharedEnv from './modules/sharedEnv';
import pageActions from './modules/pageActions';
import searchEngine from './modules/searchEngine';
import navigationBar from './modules/navigationBar';
import routeNavigation from './modules/routeNavigation';
export default (() => new Vuex.Store({
  actions,
  getters,
  modules: {
    i18n,
    cart,
    user,
    layer,
    script,
    seller,
    search,
    request,
    category,
    wishlist,
    analytics,
    sharedEnv,
    pageActions,
    searchEngine,
    navigationBar,
    routeNavigation
  }
}));